import { spacer8, spacer16, spacer24, spacer32, spacer48, screenXsMax, heading3FontSize, heading4FontSize, body1FontWeight, heading3LineHeight } from '@spotify-internal/encore-foundation';
import React from 'react';
import styled from 'styled-components';
import { articleMarkdown } from '../../Markdown';
import { categoryTrackLabel, categoryUrl, ChevronLink, HELP_LIST_TRACK_CAT, SearchBarContainer } from '../util';
import { ContentBody, ContentTitle } from './common';
import { IconChevronLeft } from '@spotify-internal/encore-web';
import { SearchBar } from '../../Search';
import { useT } from '@mrkt/features/i18n';
import { getLinkStyle } from '../../ui';
import { ArticleFeedbackModule } from '../../Module/ArticleFeedbackModule';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Content = styled(ContentBody).withConfig({
  displayName: "HelpListArticle__Content",
  componentId: "sc-1hykgcq-0"
})(["max-width:800px;"]);
export var helpArticleTextStyle = "\n  font-size: ".concat(heading4FontSize, ";\n  font-weight: ").concat(body1FontWeight, ";\n  line-height: ").concat(heading3LineHeight, ";\n");
var Subsection = styled.div.withConfig({
  displayName: "HelpListArticle__Subsection",
  componentId: "sc-1hykgcq-1"
})(["@media (max-width:", "){color:", ";background-color:", ";padding:", ";margin-bottom:", ";border-radius:", ";}"], screenXsMax, function (_ref) {
  var theme = _ref.theme;
  return theme.help.grayBox.text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.help.grayBox.background;
}, spacer16, spacer16, spacer8);
var Body = styled.div.withConfig({
  displayName: "HelpListArticle__Body",
  componentId: "sc-1hykgcq-2"
})(["a{", " text-decoration:underline;&:hover:not(:focus):not(:disabled){color:", ";}}h2{font-size:", ";}ul,ol{margin:auto;padding-left:", ";}ol > li,ul > li{", " display:revert;}p{", " margin:auto;max-width:unset;}p,ul,ol{padding-bottom:", ";}img{width:100%;}table{margin-bottom:", ";}"], function (props) {
  return getLinkStyle(props);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.help.link.hover;
}, heading3FontSize, spacer48, helpArticleTextStyle, helpArticleTextStyle, spacer16, spacer32);
var Back = styled.div.withConfig({
  displayName: "HelpListArticle__Back",
  componentId: "sc-1hykgcq-3"
})(["a{", "}padding-bottom:", ";"], function (props) {
  return getLinkStyle(props);
}, spacer24);
export var FaqArticleView = function FaqArticleView(_ref4) {
  var article = _ref4.article,
      category = _ref4.category;
  var t = useT();
  var text = article.answer;
  var subsections = [text].map(function (md) {
    return articleMarkdown(md, false);
  });
  return /*#__PURE__*/_jsxs(Content, {
    children: [/*#__PURE__*/_jsx(Back, {
      children: /*#__PURE__*/_jsx(ChevronLink, {
        "aria-label": t('FRODOR_CONTENT_NAVIGATION_LINK_BACK', 'Back', 'Back means previous in this case'),
        track: [HELP_LIST_TRACK_CAT, "Back to ".concat(categoryTrackLabel(category))],
        href: categoryUrl(category),
        children: /*#__PURE__*/_jsx(IconChevronLeft, {
          "aria-hidden": "true"
        })
      })
    }), /*#__PURE__*/_jsx(SearchBarContainer, {
      "data-testid": "help-search-bar",
      children: /*#__PURE__*/_jsx(SearchBar, {
        contentTypes: ['faq'],
        placeholder: t('FRODOR_SEARCH_BOX_PLACEHOLDER', 'Search help articles', ''),
        suggestCount: 5,
        trackCategory: HELP_LIST_TRACK_CAT,
        getSuggestUrl: function getSuggestUrl(sug) {
          return "".concat(sug.url, "?ref=sug_").concat(HELP_LIST_TRACK_CAT).concat(category ? "&category=".concat(category.urlSlug) : '');
        }
      })
    }), /*#__PURE__*/_jsx(ContentTitle, {
      children: article.question
    }), /*#__PURE__*/_jsx(Body, {
      children: subsections.map(function (section, index) {
        return /*#__PURE__*/_jsx(Subsection, {
          dangerouslySetInnerHTML: {
            __html: section
          }
        }, index);
      })
    }), /*#__PURE__*/_jsx(ArticleFeedbackModule, {})]
  });
};